// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2xwbl","info":"Note_info__3ojgz","note":"Note_note__3mnz6","actions":"Note_actions__3Pdyr"};